import React from 'react';
import { Card, Upload, message } from 'antd';

const ContentLibraryPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  return (
    <div className="container-fluid" style={{ padding: 24 }}>
      {contextHolder}
      <Card title="Content Library">
        <Upload.Dragger beforeUpload={() => { messageApi.info('Stub upload'); return false; }} multiple>
          <p>Drag & drop files here or click to upload</p>
        </Upload.Dragger>
      </Card>
    </div>
  );
};

export default ContentLibraryPage;
